function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#locked_conversation_svg__clip0_1097_1340)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.567 9.667H9.1c.373 0 .56 0 .703-.073a.666.666 0 00.291-.291c.073-.143.073-.33.073-.703v-.533c0-.374 0-.56-.073-.703a.666.666 0 00-.291-.291C9.66 7 9.473 7 9.1 7H6.567c-.374 0-.56 0-.703.073a.666.666 0 00-.291.291c-.073.143-.073.33-.073.703V8.6c0 .373 0 .56.073.703a.667.667 0 00.291.291c.143.073.33.073.703.073zM9 7V5.833a1.167 1.167 0 00-2.333 0V7H9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.311 13.853c.587.352.88.528 1.119.545a1 1 0 00.962-.544c.108-.214.108-.556.108-1.24V6.5c0-1.867 0-2.8-.363-3.513A3.333 3.333 0 0012.68 1.53c-.713-.363-1.646-.363-3.513-.363H6.5c-1.867 0-2.8 0-3.513.363-.627.32-1.137.83-1.457 1.457-.363.713-.363 1.646-.363 3.513v1.333c0 1.867 0 2.8.363 3.514.32.627.83 1.137 1.457 1.456.713.364 1.646.364 3.513.364h3.332c.408 0 .612 0 .812.024.33.04.654.13.959.265.183.082.358.187.708.397z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "locked_conversation_svg__clip0_1097_1340"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.667 .667)",
  d: "M0 0h14.333v14.234H0z"
})));

var SvgLockedConversation = function SvgLockedConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLockedConversation;